import { Component, OnInit, Input } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { AppConstants } from '../../../../app.constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../../api.service';
import { FunctionsService } from '../../../../services/functions.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cancel-subscription',
  templateUrl: './cancel-subscription.component.html'
})

export class CancelSubscriptionComponent implements OnInit {
  @Input() set endDate(value: any) {
    this._endDate = value;
  }
  @Input() set subscriptionId(value: any) {
    this._subscriptionId = value;
  }
  constructor(
    private formBuilder: UntypedFormBuilder,
    public functionsService: FunctionsService,
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    public language:TranslateService) { }

  _endDate: any;
  _subscriptionId: any;
  formSubmitted: boolean = false;
  owner = false;

  cancelSubscriptionForm = this.formBuilder.group({
    cancelReason: ['', [Validators.required]],
    cancelComment: ['', [Validators.pattern(AppConstants.cancelSubRegExp), Validators.required]],
  });

  ngOnInit() {
    document.getElementById("otherBox").hidden=true;
    if(localStorage.getItem('isOwner')!=null && localStorage.getItem('isOwner')=="1"){
      this.owner = true;
    }
  }

  cancelSubscription(){
    var required = true;
    if(this.cancelSubscriptionForm.value["cancelReason"] != "Other"){
        this.cancelSubscriptionForm.value["cancelComment"] = "";
        required = false;
    } 

    if (!this.cancelSubscriptionForm["controls"]["cancelReason"]["valid"] || (required && !this.cancelSubscriptionForm["controls"]["cancelComment"]["valid"])) {
        this.formSubmitted = true;
        return;
    } 
    
    if(this.cancelSubscriptionForm.value["cancelReason"] == "Other"){
      this.cancelSubscriptionForm.value["cancelComment"] = this.cancelSubscriptionForm.value["cancelComment"].trim();
    }
    
    this.cancelSubscriptionForm.value['subscriptionId'] = this._subscriptionId;

    this.apiService.cancelSubscription(this.cancelSubscriptionForm.value).subscribe(
        () => {
          this.activeModal.close();
        },
        error => {
            this.functionsService.errorHandler(error["status"]);
        }
    );
  }

  hideBox(){
    document.getElementById("otherBox").hidden=true;
  }

  openBox(){
    document.getElementById("otherBox").hidden=false;
  }

  get cancelComment() { return this.controlGetter('cancelComment'); }
  get cancelReason() { return this.controlGetter('cancelReason'); }

  controlGetter(controlName) {
    const control =  this.cancelSubscriptionForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }
}
